<template>
  <div class="md-layout">
    <YvIndex
      ref="allListTable"
      :path="path"
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :disabledHeaderActions="true"
      :sort-data="sortData"
      :tableActionsComponent="TableActions"
      :additional-params="paramsProps"
      :formatTableData="formatTableData"
    >
    </YvIndex>
  </div>
</template>
<script>
import YvIndex from "@/components/Base/YvIndex";
import TableActions from "../AllList/TableActions";
import { DEFAULT_OPTION_ALL } from "@/constants";
import { service_names } from "@/constants/Services";
import Swal from "sweetalert2";
import { getId, Message } from "@/helpers/utils";
import { convertDateFromServer } from "@/helpers/datetime-helper";

export default {
  props: ["tabName"],
  components: {
    YvIndex
  },
  data() {
    const TASK_TYPE = {
      mainTask: "main-task",
      individualTask: "individual-task"
    };
    return {
      TASK_TYPE,
      TableActions,
      path: `${service_names.school}/task-managements`,
      paramsProps: { filter_assigneed: this.tabName },
      formSearch: [
        {
          label: "task_management.title",
          name: "title",
          value: "",
          type: "input"
        },
        {
          label: "task_management.type",
          name: "type",
          value: "",
          type: "select",
          options: [
            ...DEFAULT_OPTION_ALL,
            { id: "main-task", name: "task_management.main_task" },
            { id: "individual", name: "task_management.individual_task" }
          ]
        },
        {
          label: "task_management.created_time",
          name: "sent_date",
          value: [],
          type: "date-range",
          width: 30
        },
        {
          label: "task_management.owner",
          name: "owner_id",
          value: "",
          fields: {
            text: "name",
            value: "id"
          },
          type: "autocomplete",
          options: [],
          refetchOptions: this.fetchOwner,
          searchKey: "search_key",
          width: 30
        }
      ],
      columns: {
        title: "task_management.title",
        taskType: "task_management.type",
        createdTime: "task_management.created_time",
        owner: "task_management.owner"
      },
      sortData: {
        currentSort: "id",
        currentSortOrder: "desc"
      }
    };
  },
  created() {
    if (this.tabName === "owned") {
      this.formSearch.pop();
      return;
    }
    this.fetchOwner();
  },
  methods: {
    fetchOwner(param) {
      return this.$axios
        .get(
          `${service_names.school}/task-managements/owner`,
          param,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(res => {
          this.formSearch[3].options = res.data.data.map(item => ({
            id: getId(item),
            name: item.full_name + " - " + item.staff_code
          }));
        });
    },
    formatTableData(data) {
      let tableData = data.map(item => ({
        ...item,
        id: getId(item),
        title: item.project_name,
        taskType:
          item.type === this.TASK_TYPE.mainTask
            ? `<span style="color: #007AFF">${this.$t(
                "task_management.main_task"
              )}</span>`
            : `<span style="color: #4CAF50">${this.$t(
                "task_management.individual_task"
              )}</span>`,
        createdTime: convertDateFromServer(item.created_at, "date"),
        owner: item.full_name,
        type: item.type
      }));
      return tableData;
    },
    async confirmDelete(item) {
      let allowDeleteMainTask = false;
      if (item.type === "main-task") {
        allowDeleteMainTask = await this.$axios
          .get(`${service_names.school}/main-task/${item.id}`)
          .then(res => {
            return res.data.subtasks.every(
              subtask => subtask.sub_task_status?.name === "assigned"
            );
          });
      }
      if (item.type === "individual" || allowDeleteMainTask) {
        Swal.fire({
          title: this.$t("common.are_you_sure"),
          text: this.$t("task_management.delete_title"),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          confirmButtonText: this.$t("common.yes_delete_it"),
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.deleteTask(item);
          }
        });
      } else {
        Message.error(this.$t("task_management.not_allow_delete"));
      }
    },
    deleteTask(item) {
      let path =
        item.type === this.TASK_TYPE.mainTask
          ? `${service_names.school}/main-task/${item.id}`
          : `${service_names.school}/sub-task/${item.id}`;
      this.$axios.delete(path).then(() => {
        Message.success(this.$t("common.delete_success"));
        this.$refs.allListTable.getTableData();
      });
    }
  },
  provide() {
    return {
      confirmDelete: this.confirmDelete
    };
  }
};
</script>
<style lang="scss" scoped></style>
